module.exports = __webpack_public_path__ + "static/img/indexCover01.4d40bd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/indexCover01.png
// module id = loky
// module chunks = 3